import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Table, Image, Row, Modal, Button, Col } from "react-bootstrap";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SmallRatingReviewReusableComponent } from "../../superAdminRatingReviews/InsidePageComponent/SmallRatingReviewReusableComponent";
import { VendorRatingReviewTableHead } from "../superAdminVendorTable/ratingReviewTable/VendorRatingReviewTableHead";
import { VendorRatingReviewTablebody } from "../superAdminVendorTable/ratingReviewTable/VendorRatingReviewTablebody";
import AddRatingReviewPopup from "../../../superAdminReusable/reusablePopupSuperAdmin/ratingAndReviews/AddRatingReviewPopup";
import BasicPagination from "../../../../Pagination/Pagination";
import ReactStars from "react-rating-stars-component";
import moment from "moment";
import Seating from "./VendorRatingReviewInsidePages/Seating";

import { get_vendor_single_rating_review } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import General from "./VendorRatingReviewInsidePages/General";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

const VendorRatingReviewDisplayPage = (props) => {
  const [showView, setShowView] = useState(false);
  const handleShowView = () => setShowView(true);
  const handleCloseView = () => setShowView(false);
  const [selectedTab, setSelectedTab] = useState("0");
  const [page, setPage] = useState(1);

  const handleBatchChange = (pageNo) => {
    setPage(pageNo);
  };
  const handleTab = (e) => {
    setSelectedTab(e);
    props.get_vendor_single_rating_review(location.state.data, e);
    setVendorInfo(location.state.data);
  };

  const [showLoading, setShowLoading] = useState(false);

  const [allReviewData, setReviewData] = useState([]);
  useEffect(() => {
    setReviewData(props.getratingReviewInfo);
  }, []);

  const location = useLocation();
  const [vendorInfo, setVendorInfo] = useState({});

  useEffect(() => {
    props.get_vendor_single_rating_review(location.state.data, 0);
    setVendorInfo(location.state.data);
  }, [location]);

  if (props.auth.loader !== false) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <Col>
                <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    {vendorInfo.restaurant_name} Review
                  </div>
                  <AddRatingReviewPopup
                    vendorData={vendorInfo}
                    selectedTab={selectedTab}
                  />
                </Col>
              </Col>
              <div className="super-admin-inside-right-side-panel pt-3">
                <Row>
                  <Col lg={4}>
                    <div className="enIMG75">
                      <Image
                        src={vendorInfo.logo_url}
                        alt="View"
                        title="View"
                        fluid
                        className="w-100 h-100"
                      />
                    </div>
                    <div className="f24-500 my-2">
                      {vendorInfo.restaurant_name}
                    </div>
                    <div className="f14-400">
                      {vendorInfo.restaurant_address}
                    </div>
                  </Col>
                  <Col lg={8}>
                    <Row>
                      <Col lg={7}>
                        <Row className="h-100">
                          <Col md={6} className="h-100">
                            <div className="small-rating-review-section h-100 d-flex align-items-center justify-content-center">
                              <div className="text-center">
                                <Image
                                  fluid
                                  all="Restaurant Rating"
                                  title="Restaurant Rating"
                                  width="30px"
                                  src={require("../../../../../assets/images/superadmin/star.svg")}
                                />
                                <div className="f36-500">
                                  {vendorInfo.averageRating} Stars
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={6} className="h-100">
                            <div className="small-rating-review-section h-100">
                              <div className="col-12 small-rating-review-sectionone flex-column">
                                <div className="f16-500 pb-1">
                                  Total Reviews
                                </div>
                                <div className="f10-400">
                                  Activity from all Time
                                </div>
                              </div>
                              <div className="col-12 small-rating-review-sectiontwo d-flex align-items-center justify-content-center">
                                <div className="f28-500 pt-4">
                                  {vendorInfo.totalReviews}{" "}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={5}>
                        <SmallRatingReviewReusableComponent
                          fiveStar={vendorInfo.rating_5start}
                          fourStar={vendorInfo.rating_4start}
                          threeStar={vendorInfo.rating_3start}
                          twoStar={vendorInfo.rating_2start}
                          oneStar={vendorInfo.rating_1start}
                          progressBar="main-progress-bar-sectiontwo"
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <hr />
                    <div className="enTabs d-flex flex-wrap align-items-center mt-4 mb-2">
                      <Button
                        onClick={(e) => handleTab("0")}
                        className={`${selectedTab === "0" ? "active" : ""}`}
                      >
                        General
                      </Button>
                      <Button
                        onClick={(e) => handleTab("1")}
                        className={`${selectedTab === "1" ? "active" : ""}`}
                      >
                        Seating
                      </Button>
                      <Button
                        onClick={(e) => handleTab("2")}
                        className={`${selectedTab === "2" ? "active" : ""}`}
                      >
                        Events
                      </Button>
                      <Button
                        onClick={(e) => handleTab("3")}
                        className={`${selectedTab === "3" ? "active" : ""}`}
                      >
                        Items
                      </Button>
                      <Button
                        onClick={(e) => handleTab("4")}
                        className={`${selectedTab === "4" ? "active" : ""}`}
                      >
                        Orders
                      </Button>
                      <Button
                        onClick={(e) => handleTab("5")}
                        className={`${selectedTab === "5" ? "active" : ""}`}
                      >
                        Pay
                      </Button>
                    </div>
                    {selectedTab === "0" && (
                      <General reviewData={allReviewData} />
                    )}
                    {selectedTab === "1" && (
                      <Seating reviewData={allReviewData} />
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

VendorRatingReviewDisplayPage.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  getratingReviewInfo: state.adminAllVendorsInfo.superAdminSingleReview,
});

export default connect(mapStateToProps, {
  get_vendor_single_rating_review,
})(withRouter(VendorRatingReviewDisplayPage));
